export default __webpack_public_path__ + "static/media/sol-dvss-MenosQueaMetadeDoTempo.6d5ebbf9.jpeg";